import { loadState } from "./localStorage";
import dayjs from "dayjs";
import jwt_decode from "jwt-decode";
import { GUEST_SERVICE_TOKEN } from "store/constants/actions";

export const isTokenValid = () => {
  const token = loadState(GUEST_SERVICE_TOKEN);
  try {
    const decodedJwt = jwt_decode(token);

    // jwt stores exp time as unix seconds timestamp
    return !(decodedJwt.exp < dayjs().unix());
  } catch (err) {
    return false;
  }
};
